<template>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h4 mr-r10">대상 목록</div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" :disabled="checkedRows.length === 0" @click="onClickReleaseButton">해제</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool" size="mini"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :data="checkedObjList" :columns="tableColumns" :column-default="columnDefault" ref="selectedObjTable"
        :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeCheckedRow">
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WSelectedObjTable',
  props: {
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    customTableColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      checkedRows: [],
      columns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'objDefineName',
          label: '관리구분',
          width: 110,
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'objName',
          label: '대상명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          searchable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  computed: {
    tableColumns() {
      if (isEmpty(this.customTableColumns)) {
        return this.columns;
      }
      return this.customTableColumns;
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    onClickReleaseButton() {
      this.$emit('change-obj-list', this.checkedRows, false);
      this.$emit('reload-obj-list');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/table/CheckObjTable/components/SelectedObjTable.vue